import React, {useEffect, useState, useRef} from 'react'
import {useSelector} from 'react-redux';
import DataTable from 'react-data-table-component';
import {get_beneficiary_reimbursement, getBeneficiaryApprovalStatus, deleteReimbursement} from "../../helper/Api";
import {AiOutlineEye} from 'react-icons/ai';
import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import { FaEdit } from 'react-icons/fa';
import { BiTrash } from 'react-icons/bi';
import StatusModal from './StatusModal';
import './BeneficiaryReimbursementList.css';
import { toast } from "react-toastify";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

export default function BeneficiaryReimbursementList(filterData) {
    const [showPreview, setShowPreview]=useState(false);
    const {authData} = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState([]);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [rowPendingDelete, setRowPendingDelete] = useState(null);
    const {listType} = useParams();
    const approvalLogsData = useRef({
        ownData: {},
        logs: []
    });


    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };
    let paymentColumns = [{
        name: 'Payment L2',
        selector: (row) => row.approval_type === 'single' ? '-' : row.l2_payment_approval == null ? "Pending" : row.l2_payment_approval == 1 ? "Approved" : "Rejected",
        wrap: true,
        width: "100px"
    },
    {
        name: 'Payment L3',
        selector: (row) => row.l3_payment_approval == null ? "Pending" : row.l3_payment_approval == 1 ? "Approved" : "Rejected",
        wrap: true,
        width: "100px"
    },];

    if(listType && listType == 'approval') {
        paymentColumns = [];
    }

    const viewStatusLogs = async (row) => {
        approvalLogsData.current.ownData = {
            l2_approval: row.l2_approval,
            l3_approval: row.l3_approval,
            department_level: row.department_level,
            reimbursement_order_no: row.reimbursement_order_no,
        };
        const result = await getBeneficiaryApprovalStatus(row.id);
        if(result.data.status) {
            if(result.data.result.length) {      
                let data = result.data.result;
                approvalLogsData.current.logs = data;
            }
        }
        setShowPreview(true);
    }

    const openDeleteConfirm = (row) => {
        setRowPendingDelete(row);
        setDeleteConfirmOpen(true);
    };

    const closeDeleteConfirm = () => {
        setDeleteConfirmOpen(false);
        setRowPendingDelete(null);
    };

    const confirmDelete = async () => {
        if (!rowPendingDelete?.id) return;
        try {
            const res = await deleteReimbursement(rowPendingDelete.id);
            if (res?.data?.status) {
                toast.success(res?.data?.message || "Deleted successfully.", {
                    position: toast.POSITION.TOP_CENTER,
                });
                closeDeleteConfirm();
                await fetchChallans();
            } else {
                toast.error(res?.data?.message || "Delete failed.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } catch (err) {
            toast.error(
                err?.response?.data?.message || err?.message || "Delete failed.",
                { position: toast.POSITION.TOP_CENTER }
            );
        }
    };

    const columns = [
        {
            name: 'Actions',
            selector: (row) => {
                const canDelete =
                    String(authData?.user?.user_type || '').toLowerCase() === 'l1' &&
                    ((String(row?.l2_approval) === '0' || Number(row?.l2_approval) === 0) ||
                        (String(row?.l3_approval) === '0' || Number(row?.l3_approval) === 0));
                return (
                    <>
                    <div className='br_reimbursement_user_action'>
                        <Link to={`/add-beneficiary-reimbursement/${row.id}`} title="View">
                            <AiOutlineEye/>
                        </Link>
                        {
                            (authData.user.user_type === 'l1' && authData.user.department_id == row.department_id && (row.l2_approval == 0 || row.l3_approval == 0 || row.rejection)) ? (
                                <Link to={`/edit-beneficiary-reimbursement/${row.id}`} title="Edit">
                                    <FaEdit/>
                                </Link>
                            ) : ''
                        }
                        {canDelete ? (
                            <button
                                type="button"
                                className="border-0 bg-transparent p-0 text-danger"
                                title="Delete"
                                onClick={() => openDeleteConfirm(row)}
                                aria-label={`Delete reimbursement ${row.reimbursement_order_no || row.id}`}
                            >
                                <BiTrash size={18} />
                            </button>
                        ) : ''}
                        </div>
                    </>
                )
            },
            wrap: true,
            width: "140px",
            minWidth: "130px",
            center: true
        },
        {
            name: 'Dept. Name',
            selector: (row) => row.department_name,
            wrap: true,
            width: "180px",
            minWidth: "160px",
        },
        {
            name: 'Dept. Level',
            selector: (row) => row.department_level,
            wrap: true,
            width: "130px",
            minWidth: "120px",
        },
        {
            name: 'Order No',
            selector: (row) => row.reimbursement_order_no,
            wrap: true,
            width: "240px",
            minWidth: "220px",
        },
        {
            name: 'Order Date',
            selector: (row) => row.reimbursement_order_date,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Type',
            selector: (row) => row.type,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Order Amount',
            selector: (row) => row.reimbursement_order_value,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Financial Year',
            selector: (row) => row.financial_year,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Scheme Code',
            selector: (row) => row.code,
            wrap: true,
            width: "140px",
            minWidth: "120px",
        },
        {
            name: 'Scheme Name',
            selector: (row) => row.name,
            wrap: true,
            width: "300px"
        },
        {
            name: 'Subhead Code',
            selector: (row) => row.subhead_code,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Subhead Name',
            selector: (row) => row.subhead_name,
            wrap: true,
            width: "300px"
        },
        {
            name: 'Creation Date',
            selector: (row) => row.created_at,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Status Logs',
            wrap: true,
            width: '100px',
            selector: (row) => {
                let classNameVar = row.rejection && row.rejection !== '' ? 'btn btn-danger' : 'btn btn-primary';
                return (
                    <button type="button" className={classNameVar} onClick={() => viewStatusLogs(row)}><AiOutlineEye/></button>
                )
            }

        },
        ...paymentColumns
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    const fetchChallans = async () => {
        try {
            const resp = await get_beneficiary_reimbursement({
                from_date: filterData?.fromDate || '', 
                to_date: filterData?.toDate || '',
                search_str: filterData?.searchStr || '',
                dateColumn: filterData?.dateColumn || '',
                department_id: filterData?.departmentId || '',
                listType: listType == 'dbt_payment' ? '' : listType,
                is_all: filterData?.is_all || ''
            });
            if (resp.data.status) {
                setData(resp.data.result);
            }
        } catch (error) {
            setData([]);
        }
    }

    useEffect(() => {
        fetchChallans();
    }, [filterData.fromDate, filterData.toDate, filterData.dateColumn, filterData.searchStr, filterData.departmentId, listType, filterData.is_all]);



    return (
        <div>
            <StatusModal showPreview={showPreview} setShowPreview={setShowPreview} approvalLogs={approvalLogsData?.current?.logs} data={approvalLogsData?.current?.ownData}/>
            <Dialog
                open={deleteConfirmOpen}
                onClose={closeDeleteConfirm}
                maxWidth="xs"
                fullWidth
                aria-labelledby="br-delete-title"
            >
                <DialogTitle id="br-delete-title">Delete reimbursement</DialogTitle>
                <DialogContent dividers>
                    <p className="mb-0" style={{ fontSize: 15, lineHeight: 1.5 }}>
                        Are you sure you want to delete this reimbursement invoice? This action cannot be undone.
                    </p>
                    {rowPendingDelete && (
                        <p className="mt-2 mb-0 text-muted small">
                            Order No.: <strong>{rowPendingDelete.reimbursement_order_no ?? "—"}</strong>
                        </p>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 2.5, pb: 2 }}>
                    <Button onClick={closeDeleteConfirm} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} variant="contained" color="error">
                        Yes, delete
                    </Button>
                </DialogActions>
            </Dialog>
            <div className="beneficiary-reimbursement-datatable-root">
                <DataTable
                    customStyles={customStyles}
                    className="dataTables_wrapper"
                    columns={columns}
                    data={data}
                    fixedHeader
                    fixedHeaderScrollHeight="600px"
                    pagination
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={data.length}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </div>
        </div>
    )

}